import { DEFAULT_PAGE_INFO } from '@apeiron/common'
import {
  BattlePassPrizeHistoryFilterInput,
  BattlePassPrizeHistoryType,
  deserializeListData,
  deserializePageInfo,
  PageInfo,
  PageInput,
  serializePagingInput
} from '@apeiron/temp'
import { useLazyQuery } from '@apollo/client'
import { battlePassPrizeHistorySchema } from '@src/deserialize/yup/battlePass'
import graphql from '@src/graphql/query/getBattlePassPrizeHistories'
import { useState } from 'react'

const useGetBattlePassPrizeHistories = (): Hook => {
  const [query, { loading }] = useLazyQuery(graphql)

  const [data, setData] = useState<BattlePassPrizeHistoryType[]>([])

  const [pageInfo, setPageInfo] = useState<PageInfo>(DEFAULT_PAGE_INFO)

  const fetch = async (request: Request): Promise<Response> => {
    const { pageInput = {}, filterInput = {} } = request

    const variables = {
      pagingInput: serializePagingInput(pageInput),
      filterInput
    }

    const response = await query({ variables })

    const rewardData = deserializeListData<BattlePassPrizeHistoryType>(
      response,
      battlePassPrizeHistorySchema
    )

    const pageInfo = deserializePageInfo(response, pageInput)

    setData(rewardData)
    setPageInfo(pageInfo)

    return {
      data: rewardData,
      pageInfo
    }
  }

  return {
    data,
    fetch,
    pageInfo,
    loading
  }
}

type Request = {
  pageInput?: PageInput
  filterInput?: BattlePassPrizeHistoryFilterInput
}

type Response = {
  data: BattlePassPrizeHistoryType[]
  pageInfo: PageInfo
}

type Hook = {
  data: BattlePassPrizeHistoryType[]
  fetch: (request: Request) => Promise<Response>
  pageInfo: PageInfo
  loading: boolean
}

export default useGetBattlePassPrizeHistories
